import instance from './instance'

export function getChannels(id = '') {
    return instance.get(`/settings/channels/${id}`)
}

export function getCampaignWeOn() {
    return instance.get(`/settings/weon/campaigns`)
}
